// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
    Action button loader
 */
.btn-loader {
    width:24px;
    height:24px;
    border-radius:50%;
    border:4px solid;
    animation:s1 1s infinite;
}

.btn-loader-dark{
    border-color:#0A0C17 #0000;
}

.btn-loader-light{
    border-color: white #0000;
}

@keyframes s1 {to{transform: rotate(.5turn)}}

/*
    mini button loader
 */
.mini-loader {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 4px solid #0000;
    position: relative;
    animation: s4 1s infinite linear;
}
.mini-loader:before,
.mini-loader:after {
    content: "";
    position: absolute;
    inset:-4px;
    border-radius: 50%;
    border:inherit;
    animation:inherit;
    animation-duration: 2s;
}
.mini-loader:after {
    animation-duration: 4s;
}

@keyframes s4 {
    100% {transform: rotate(1turn)}
}

/*
    big loader
 */

.big-loader {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 8px solid #0000;
    border-right-color: #0186D097;
    position: relative;
    animation: s5 1s infinite linear;
}
.big-loader:before,
.big-loader:after {
    content: "";
    position: absolute;
    inset:-8px;
    border-radius: 50%;
    border:inherit;
    animation:inherit;
    animation-duration: 2s;
}
.big-loader:after {
    animation-duration: 4s;
}

@keyframes s5 {
    100% {transform: rotate(1turn)}
}

@keyframes fading {
    0% {
        opacity: 0.1;
    }
    100%{
        opacity: 1;
    }
}

.fadingAnim {
    animation: fading 1s infinite linear;
}

@keyframes scaleoutAnim {
    0% {
        transform: translateX(400px);
        opacity: 0.5;
    }
    100%{
        transform: translateX(0);
        opacity: 1;
    }
}

.scaleout {
    animation: scaleoutAnim 0.3s forwards linear;
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/loader.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,eAAe,GAAG,yBAAyB,CAAC;;AAE5C;;EAEE;AACF;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,gCAAgC;AACpC;AACA;;IAEI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,MAAM,wBAAwB;AAClC;;AAEA;;EAEE;;AAEF;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,gCAAgC;AACpC;AACA;;IAEI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,MAAM,wBAAwB;AAClC;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,4BAA4B;QAC5B,YAAY;IAChB;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,4CAA4C;AAChD","sourcesContent":["/*\n    Action button loader\n */\n.btn-loader {\n    width:24px;\n    height:24px;\n    border-radius:50%;\n    border:4px solid;\n    animation:s1 1s infinite;\n}\n\n.btn-loader-dark{\n    border-color:#0A0C17 #0000;\n}\n\n.btn-loader-light{\n    border-color: white #0000;\n}\n\n@keyframes s1 {to{transform: rotate(.5turn)}}\n\n/*\n    mini button loader\n */\n.mini-loader {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    border: 4px solid #0000;\n    position: relative;\n    animation: s4 1s infinite linear;\n}\n.mini-loader:before,\n.mini-loader:after {\n    content: \"\";\n    position: absolute;\n    inset:-4px;\n    border-radius: 50%;\n    border:inherit;\n    animation:inherit;\n    animation-duration: 2s;\n}\n.mini-loader:after {\n    animation-duration: 4s;\n}\n\n@keyframes s4 {\n    100% {transform: rotate(1turn)}\n}\n\n/*\n    big loader\n */\n\n.big-loader {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    border: 8px solid #0000;\n    border-right-color: #0186D097;\n    position: relative;\n    animation: s5 1s infinite linear;\n}\n.big-loader:before,\n.big-loader:after {\n    content: \"\";\n    position: absolute;\n    inset:-8px;\n    border-radius: 50%;\n    border:inherit;\n    animation:inherit;\n    animation-duration: 2s;\n}\n.big-loader:after {\n    animation-duration: 4s;\n}\n\n@keyframes s5 {\n    100% {transform: rotate(1turn)}\n}\n\n@keyframes fading {\n    0% {\n        opacity: 0.1;\n    }\n    100%{\n        opacity: 1;\n    }\n}\n\n.fadingAnim {\n    animation: fading 1s infinite linear;\n}\n\n@keyframes scaleoutAnim {\n    0% {\n        transform: translateX(400px);\n        opacity: 0.5;\n    }\n    100%{\n        transform: translateX(0);\n        opacity: 1;\n    }\n}\n\n.scaleout {\n    animation: scaleoutAnim 0.3s forwards linear;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
